export default __webpack_public_path__ + "static/media/astitva-logo.03f3e93a.png";